import React from 'react';

export interface PageHeaderProps {
  title: string;
  description?: string;
  /** Optional action area on the right (buttons, switches, etc.). */
  children?: React.ReactNode;
}

/**
 * Page header used at the top of every screen. Layout matches My.Tms.Old —
 * title (xl bold slate-700), optional description, optional right-side
 * action area, slate-200 bottom border.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, description, children }) => {
  return (
    // min-h-16 matches the sidebar header (also min-h-16, border included), so
    // the two bottom borders run as one line across the screen whatever the
    // page puts in its header — a description, a button, or nothing at all.
    <div className="mb-1.5 min-h-16 border-b border-slate-200">
      {/* --page-header-inset: room an app keeps clear on the right for a
          control it pins to the top-right corner (TMS's driver messages).
          Unset in every other app, so nothing moves there. */}
      <div
        className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between"
        style={{ paddingRight: 'var(--page-header-inset, 0px)' }}
      >
        <div>
          <h1 className="text-xl font-bold text-slate-700">{title}</h1>
          {description && <p className="text-slate-600">{description}</p>}
        </div>
        {children ? (
          <div className="flex items-center gap-3">{children}</div>
        ) : (
          <div className="mb-9">&nbsp;</div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
